import { DownArrow } from 'icons';
import React, { useState } from 'react';

/* eslint-disable no-unused-vars */
interface DropdownFieldProps {
  label: string;
  name: string;
  value: string;
  options: { label: string; value: string }[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  labelSize?: number;
  labelWidth?: number;
  fullWidth?: boolean;
  showIcon?: boolean;
  inputText?: number;
  disabled?: boolean;
  error?: string;
}

export const Dropdown = ({
  label,
  name,
  value,
  options,
  onChange,
  labelSize,
  labelWidth,
  fullWidth,
  showIcon,
  inputText,
  disabled,
  error,
}: DropdownFieldProps) => {
  const [isFocused, setIsFocused] = useState(false);
  const errorId = error ? `${name}-error` : undefined;

  return (
    <label
      className={`flex flex-col relative text-[#4F5057] -z-0 ${
        labelWidth ? '' : 'font-[400]'
      } ${fullWidth ? 'w-full' : ''}`}
      style={{
        fontSize: labelSize ? `${labelSize}px` : '14px',
        fontWeight: labelWidth || undefined,
      }}
    >
      {label}
      <select
        disabled={disabled}
        name={name}
        value={value}
        onChange={onChange}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        aria-label={label || name}
        aria-invalid={error ? true : undefined}
        aria-describedby={errorId}
        style={{
          appearance: 'none',
          WebkitAppearance: 'none',
          MozAppearance: 'none',
          zIndex: 0,
          fontSize: inputText ? `${inputText}px` : '16px',
        }}
        className={`border border-[#D5D9DF] placeholder-[#ABB4BF] placeholder:font-normal rounded-[5px] px-[16px] h-[48px] md:h-[45px]
			${isFocused || !value ? 'bg-white' : 'bg-[#F4F4F4]'}
			${fullWidth ? 'w-full' : ''}
			${error ? 'border-red-500' : ''}
			${disabled ? 'opacity-60' : ''}
		  text-[#4F5057] font-medium`}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {showIcon ? (
        <div className="absolute right-[16px] self-center bottom-[17px] pointer-events-none">
          <DownArrow />
        </div>
      ) : (
        <></>
      )}
      {error && (
        <div id={errorId} className="text-red-500 text-sm mt-1">
          {error}
        </div>
      )}
    </label>
  );
};
